import { POST } from "../../index";

export const selectDriverState = (param) => POST("/v1/DDriverStateController/selectDriverState", param);
export const selectStopEvent = (param) => POST("/v1/DDriverStateController/selectStopEvent", param);
